import { ApiGetRequest, ECertificateDocumentType } from 'types';

import { IEecsCompany } from 'modules/eecs-go';

export enum EMediaCollections {
  MAIN_IMAGE = 'main_image',
  IMAGES = 'images',
  CERTIFICATES = 'certificates',
  AVATAR = 'avatar',
  ID_DOCUMENT = 'id_document',
  LOGO = 'logo',
  MARKETPLACE_LOGO = 'marketplace_logo',
  FAVICON = 'favicon',
  QR_CODE_LOGO = 'qr_code_logo',
  ICON = 'icon',
}

export enum EMediaModelTypes {
  USER = 'users',
  COMPANY = 'companies',
  PRODUCTION_DEVICE = 'necs-production-device',
}

export interface MediaAdditionalFields {
  show_on_exchange?: boolean | number;
  document_type?: ECertificateDocumentType;
  file_name?: string;
}

export interface UploadMediaBody extends MediaAdditionalFields {
  'files[]': File[];
}

export interface UploadMediaPayload extends MediaAdditionalFields {
  id: number | string;
  modelType: string;
  collection: EMediaCollections;
  files: File[];
}

interface UploadMediaRequestBody {
  body: UploadMediaBody;
}

export interface UploadMediaRequest extends UploadMediaRequestBody {
  params: {
    id: number | string;
    modelType: string;
    collection: string;
  };
}

export interface UpdateMediaPayload extends MediaAdditionalFields {
  id: number;
}

export interface UpdateMediaRequest extends UpdateMediaPayload {}

export interface DeleteMediaRequest {
  id: number | string;
}

export interface IMedia {
  id: number;
  url: string;
  thumb_url: string;
  name: string;
  size: string;
  mime_type: string;
  extension: string;
  created_at: string;
  type?: ECertificateDocumentType;
  rdid?: string;
  model_type: EMediaModelTypes;
  model_id: number | string;
  uploaded_user?: {
    id: number;
    first_name: string;
    last_name: string;
    avatar_url?: string;
  };
  company?: IEecsCompany;
}

export interface UploadMediaResponse {
  id: number;
  message: string;
  thumb_url: string;
  url: string;
}

export interface FetchMediaPayload extends ApiGetRequest {
  collection: IMediaCollection[];
  order_by_created_at?: 'asc' | 'desc';
  order_by_type?: 'asc' | 'desc';
  filter_by_create_date_start?: string;
  filter_by_create_date_end?: string;
  filter_by_company_id?: number;
  withAddItems?: boolean;
}

export interface ConvertMediaPayload {
  url: string;
  name: string;
  mimeType: string;
  extension: string;
  withDownload?: boolean;
}

export interface IMediaCollection {
  name: EMediaCollections;
  model_type: String;
}

export interface GetCollectionsPayload {
  type: 'documents' | 'images';
}
